module.exports = __webpack_public_path__ + "img/1455909778.06be7bb7.jpg";